import("dialog-helper").then(dh => dh.setup());

Promise.all([
    import("deprecate/main"),
    import("deprecate/auth"),
    import("bootstrap/js/dropdown"),
    import("tap-side-menu/tap-side-menu"),
    import("utils/equal-size"),
]);
